
define(function (require) {

  const GenericFilterCodesService = require('civicsUtils/generic_filter_codes');
  const TypeUtilities = require('civicsUtils/type_utilities');
    // A module that contains all functions related to up setting changes that
    // needs to be apply on controls/fields.
    const controlChangeManager = function () {
      this.typeOfRecord = '';

        const _applyChanges = (controlCollection, typeOfRecord) => {

          this.typeOfRecord = typeOfRecord || '';

          if (controlCollection === undefined)
            return;

          $.each(controlCollection, (index, control) => {
            let containerId = control.filter ? control.filter.filterMoniker : "";
            let $input = _getJqueryObj(control.elementId, containerId);

            if ($input && $input.length > 0) {
              _genericFilterCodes($input, control.elementId, control.filter);
            }
          });
        }

        //Function to call the module specific to generic filter codes.
        const _genericFilterCodes = ($targetField, targetFieldId, filterCodeSetup) => {

          if (filterCodeSetup === undefined)
            return;

          let filterMoniker = filterCodeSetup.filterMoniker;

          if (filterMoniker === undefined || filterMoniker.length === 0)
            return;

          let typeMatches = TypeUtilities.compareFilterMonikerType(filterMoniker, this.typeOfRecord);

          if (typeMatches !== true) {
            typeMatches = TypeUtilities.trackFilterCodeSetupList(filterMoniker);
          }

          //if type matches still not equal to true, return already and do not proceed.
          if (typeMatches !== true)
            return;

          let $finalTargetField = $targetField;
          if ($finalTargetField.length !== 1) {
            $finalTargetField = $finalTargetField.filter('.droppy-input:not([filtercodes])').first();
          }

          if ($finalTargetField.is('input') !== true)
            return;

          if ($finalTargetField.attr('filterCodes') !== 'on') {

              let filterService = new GenericFilterCodesService(); //create new instance for each field.
              filterService.render({
                $targetField: $finalTargetField,
                filterId: filterCodeSetup.filterId,
                conditionField: filterCodeSetup.conditionField,
                filterMoniker: filterMoniker,
                targetFieldId: targetFieldId,
                conditionFilterType: filterCodeSetup.conditionFilterType
              });
              //trust the response from server that all properties are there.
              //add a marker that we already applied filter code features in the input.
              $finalTargetField.attr("filterCodes", "on");
          }

        }


        /**
         * Finds an element using name or id attribute.
         * ----------------------------------------------
         * Dev notes:
         * Out of the box element => There is a very rare chance that we encounter a duplicate ID or name within the same page
         *
         * Detail page element - Because we do not define the names of the element,
         * we may encounter elements with the same names. We'll need some more identifiers
         * to properly locate the element; we may use attributes like data-detailpagemoniker or data-gridmoniker.
         * Please keep in mind that editable fields will always be present inside a modal.
         * So, if the container id matches the data-gridmoniker, the element will be located within the modal.
         */
        const _getJqueryObj = (fieldIdentifier, containerId="") => {
          //out of the box fields find it by ID attribute
          let $targetField = $('#'+fieldIdentifier);

          if ($targetField && $targetField.length == 1) {
            return $targetField;
          }
          //detail pages find it by name attribute and its container
          if ($targetField && ($targetField.length > 1 || $targetField.length == 0) && containerId.length > 0) {

            let $containerDiv = $('div').find(`[data-detailpagemoniker='${containerId}']:has([data-readonly-detailpage='false'])`);

            if ($containerDiv) {
              if ($containerDiv.length >= 1) {
                $targetField = $containerDiv.find(`[name='${fieldIdentifier}']`);
              } else {
                  let $gridContainerDiv = $(".modal-detail-el.detail-page-wrapper[data-readonly-detailpage='false']").find(`[data-gridmoniker='${containerId}']`);
                  if ($gridContainerDiv && $gridContainerDiv.length >= 1) {
                    $targetField = $(`#modal-content-add-row:has([data-gridmoniker='${containerId}'][data-readonly-detailpage='false'])`).find(`[name='${fieldIdentifier}']`);
                  }
              }
            }
          }

          return $targetField;
        }

        return {
          applyChanges: _applyChanges
        }
    }

    return controlChangeManager();
});
